class Carousel3D extends HTMLElement {
  constructor() {
    super()
    this.elements = this._getElements()
    this._isDragging = false
    this._currentPositionDegrees = 0
    this._slideNextListener = this._slideNext.bind(this)
    this._slidePrevListener = this._slidePrev.bind(this)
    this.init()
  }

  init() {
    this._setProperties()
    this.resizeObserver = new ResizeObserver(() => this._setProperties())
    this.resizeObserver.observe(this)
    this.elements.nextButton.addEventListener("click", this._slideNextListener)
    this.elements.prevButton.addEventListener("click", this._slidePrevListener)
    ;["touchstart", "mousedown"].forEach((eventType) => this.addEventListener(eventType, (e) => this._handleDragStart(e)))
    ;["touchend", "mouseup"].forEach((eventType) => this.addEventListener(eventType, (e) => this._handleDragEnd(e)))
    ;["touchmove", "mousemove"].forEach((eventType) => this.addEventListener(eventType, (e) => this._handleDrag(e)))
    setTimeout(() => {
      this.classList.remove("slider-3d__carousel--fade-in")
    }, 100)
  }

  set currentPositionDegrees(value) {
    this._currentPositionDegrees = value
    this._updateAllSlides()
  }

  _setProperties() {
    const data_slideScale = this.dataset.slideScale ? this.dataset.slideScale : 1.2;
    const data_aspectRatio = this.dataset.aspectRatio ? this.dataset.aspectRatio : "27 / 35";
    // data spect ratio can be a string like "16/9" or a number like 1.5 and needs to be converted to a number
    const aspectRatio = data_aspectRatio.includes("/") ? data_aspectRatio.split("/").reduce((a, b) => a / b) : parseFloat(data_aspectRatio)
    // check if aspect ratio is a number
    let slide_aspectRatio;
    isNaN(aspectRatio) ? slide_aspectRatio = 1 : slide_aspectRatio = aspectRatio
    const { height, width } = this.getBoundingClientRect()
    this.containerWidth = width
    this.containerHeight = height
    this.slideHeight = Math.round(width * data_slideScale)
    this.slideWidth = Math.round(width * data_slideScale * slide_aspectRatio)
    this.style.setProperty("--carousel-width", `${width}px`)
    this.style.setProperty("--image-wrapper-pos-x", `${parseInt(width) / 2}px`)
    this.style.setProperty("--image-wrapper-pos-y", `${parseInt(height) / 2}px`)
    this.style.setProperty("--slide-width", `${this.slideWidth}px`)
    this.style.setProperty("--slide-height", `${this.slideHeight}px`)
    this._updateAllSlides()
  }

  _updateAllSlides(slideOffset = 0) {
    this.elements.slides.forEach((slide) => this._updateSlideProperties(slide, slideOffset))
  }

  _updateSlideProperties(slide, slideOffset = 0) {
    const maxTranslate = this.containerWidth * 0.65
    const positionDegrees = parseInt(slide.dataset.positionDegrees) + this._currentPositionDegrees + slideOffset
    const posX = Math.round(Math.sin(this._degreesToRadians(positionDegrees)) * maxTranslate * -1 - this.slideWidth / 2)
    const posZ = Math.round(Math.cos(this._degreesToRadians(positionDegrees)) * (1000 / 2)) - 1000 / 2
    const isBackgroundImage = posZ < 1000 / -2
    const opacity = 1 + 0.0008 * posZ
    const blur = (Math.abs(posZ) / 1000) * 10 * (this.elements.slides.length / 4)
    slide.style.setProperty("--slide-pos-x", `${posX}px`)
    slide.style.setProperty("--slide-pos-z", `${posZ}px`)
    slide.style.setProperty("--slide-opacity", `${isBackgroundImage ? 0.5 : 1}`)
    // slide.style.setProperty("--slide-opacity", `${opacity}`)
    // slide.style.setProperty("--image-blur", `${blur}px`)
  }

  _slideNext() {
    this.currentPositionDegrees = this._currentPositionDegrees + 360 / this.elements.slides.length
    this._updateAllSlides()
  }

  _slidePrev() {
    this.currentPositionDegrees = this._currentPositionDegrees - 360 / this.elements.slides.length
    this._updateAllSlides()
  }

  _handleDragStart(event) {
    this._isDragging = true
    this._startingPosX = event.type.toLowerCase() === "touchstart" ? event.touches[0].clientX : event.clientX
  }

  _handleDragEnd(event) {
    event.stopPropagation()
    this._isDragging = false
    this._updateAllSlides()
  }

  _handleDrag(event) {
    if (!this._isDragging) return
    const posX = event.type.toLowerCase() === "touchmove" ? event.touches[0].clientX : event.clientX
    const draggedDelta = this._startingPosX - posX
    const dragThreshold = this.containerWidth / 5
    const slideOffset = 40 * (draggedDelta / dragThreshold)
    this._updateAllSlides(slideOffset)
    if (Math.abs(draggedDelta) > dragThreshold) {
      event.preventDefault()
      this._isDragging = false
      draggedDelta > 0 ? this._slideNext() : this._slidePrev()
    }
  }

  _getElements() {
    return {
      innerContainer: this.querySelector("[data-inner-container]"),
      imageWrapper: this.querySelector("[data-image-wrapper]"),
      slides: [...this.querySelectorAll("[data-slide]")],
      nextButton: this.querySelector("[data-next-button]"),
      prevButton: this.querySelector("[data-prev-button]"),
    }
  }

  _degreesToRadians(degrees) {
    return degrees * (Math.PI / 180)
  }

}

customElements.get("carousel-3d") || customElements.define("carousel-3d", Carousel3D)
